import { COUNTRIES_PHONE_FORMAT, CountryWithPhoneFormat } from 'config';

export const formatPhoneHun = (inputNumbers: string) => {
  const { countryCode } =
    COUNTRIES_PHONE_FORMAT[CountryWithPhoneFormat.Hungary]!;

  let formattedInputValue = `${countryCode} `;

  if (inputNumbers.length === 1) {
    formattedInputValue = `${formattedInputValue}${inputNumbers.substring(
      0,
      1,
    )}`;
  }
  if (inputNumbers.length >= 3) {
    formattedInputValue = `${formattedInputValue}${inputNumbers.substring(
      2,
      4,
    )}`;
  }
  if (inputNumbers.length >= 5) {
    formattedInputValue = `${formattedInputValue} ${inputNumbers.substring(
      4,
      7,
    )}`;
  }
  if (inputNumbers.length >= 8) {
    formattedInputValue = `${formattedInputValue} ${inputNumbers.substring(
      7,
      11,
    )}`;
  }

  return formattedInputValue;
};
